<template>
  <v-card
    :min-width="minWidth"
    flat
    :style="[
      {
        'border-radius': rounded ? '30px' : '0',
        background: '#F6F7FB !important',
      },
    ]"
  >
    <v-toolbar v-if="toolbar" :color="color" :dark="dark">
      <slot name="toolbar" />
      <v-spacer v-if="icon"></v-spacer>
      <ButtonIcon v-if="icon" :icon="$icons.dotsVertical" />
    </v-toolbar>

    <v-card-title v-else>
      <h3 v-text="title"></h3>
    </v-card-title>

    <v-card-text>
      <slot />
    </v-card-text>

    <v-card-actions>
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>
import ButtonIcon from '@/components/vuetify/ButtonIcon.vue';

export default {
  name: 'Card',
  components: { ButtonIcon },
  props: {
    title: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    toolbar: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    minWidth: {
      type: String,
      default: '350px',
    },
  },
};
</script>

<style></style>
